export function getBase64Src(imageData: string) {
  return `data:image/jpeg;base64,${imageData}`;
}
